import { useCallback, useEffect, useState } from "react";

import type { AutoSuggestedWork } from "@/api/queries";

import { useGetMyWorkAutoSuggest } from "@/api/queries";

import type { WorkSearchOption } from "../types/opportunities.types";

export default function useWorkSearch(selectedAccount: string) {
  const [searchString, setSearchString] = useState<string>("");
  const [options, setOptions] = useState<WorkSearchOption[]>([]);
  const [cachedSongs, setCachedSongs] = useState<AutoSuggestedWork[]>([]);

  const works = useGetMyWorkAutoSuggest({
    aac: selectedAccount,
    searchstring: searchString,
  });

  const handleInputChange = useCallback((inputValue: string): void => {
    setSearchString(inputValue);
  }, []);

  useEffect(() => {
    if (Array.isArray(works?.data?.works)) {
      const newSongsFromWorks = works.data.works;

      const newFetchedOptions: WorkSearchOption[] = newSongsFromWorks.map(songData => ({
        label: `${songData.title} - (${songData.performingartists})`,
        value: songData.workcode,
      }));

      setOptions((currentOptions) => {
        const currentSig = JSON.stringify(
          currentOptions
            .map(o => ({ l: o.label, v: o.value }))
            .sort((a, b) => String(a.v).localeCompare(String(b.v))),
        );
        const newSig = JSON.stringify(
          newFetchedOptions
            .map(o => ({ l: o.label, v: o.value }))
            .sort((a, b) => String(a.v).localeCompare(String(b.v))),
        );
        return currentSig !== newSig ? newFetchedOptions : currentOptions;
      });

      setCachedSongs((prevCachedSongs) => {
        const existingWorkcodes = new Set(prevCachedSongs.map(s => s.workcode));
        const songsToAdd = newSongsFromWorks.filter(
          (newSong): boolean => !!(newSong.workcode && !existingWorkcodes.has(newSong.workcode)),
        );

        if (songsToAdd.length > 0) {
          const uniqueSongsToAdd = songsToAdd.filter(
            (song, index, self) => index === self.findIndex(s => s.workcode === song.workcode),
          );
          if (uniqueSongsToAdd.length > 0) {
            return [...prevCachedSongs, ...uniqueSongsToAdd];
          }
        }
        return prevCachedSongs;
      });
    }
    else if (
      works.isLoading === false
      && works.isFetching === false
      && (!works.data || !works.data.works)
    ) {
      setOptions(currentOptions => (currentOptions.length > 0 ? [] : currentOptions));
    }
  }, [works.data, works.isLoading, works.isFetching]);

  return { options, cachedSongs, handleInputChange };
}
